import { render, staticRenderFns } from "./CollectionCode.vue?vue&type=template&id=ac87ad48&scoped=true&"
import script from "./CollectionCode.vue?vue&type=script&lang=js&"
export * from "./CollectionCode.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCode.vue?vue&type=style&index=0&id=ac87ad48&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac87ad48",
  null
  
)

export default component.exports